import FeatureAction from './FeatureAction';
import React, { useEffect, useState } from 'react';
import type { MarkerInfo, SearchResult } from '../services/api';
import SearchResultCardView, { SearchResultCardViewProps } from './SearchResultCardView';
import MarkerEditor from './MarkerEditor';

export { getSearchResultCardEvidence } from './SearchResultCardView';
export type { SearchResultCardEvidence } from './SearchResultCardView';

interface SearchResultCardProps extends Omit<SearchResultCardViewProps, 'markerAction' | 'renderDownloadAction'> {
  onMarkerChange?: (result: SearchResult, marker: MarkerInfo) => void;
}

/** Authenticated app actions wrap the same presentation used by MCP Studio. */
const SearchResultCard: React.FC<SearchResultCardProps> = ({ result, onMarkerChange, ...props }) => {
  const [marker, setMarker] = useState(result.marker);
  useEffect(() => { setMarker(result.marker); }, [result.marker]);
  const isSegment = result.result_type !== 'video';
  return <SearchResultCardView {...props} result={result} renderDownloadAction={(button) => <FeatureAction feature="export_lifecycle">{button}</FeatureAction>} markerAction={(
    <MarkerEditor
      marker={marker}
      target={{
        entity_type: isSegment ? 'segment' : 'video',
        index_id: result.source_index_id,
        run_id: result.run_id || result.source_run_id || result.prompt_run_id,
        video_id: result.video_id,
        segment_id: isSegment ? result.segment_id || undefined : undefined,
        segment_start_time: isSegment && typeof result.start_time === 'number' ? result.start_time : undefined,
        segment_end_time: isSegment && typeof result.end_time === 'number' ? result.end_time : undefined,
      }}
      onMarkerChange={(next) => { setMarker(next); onMarkerChange?.(result, next); }}
    />
  )} />;
};
export default SearchResultCard;
